<template>
  <RolesData />
  <UsersListing />
</template>

<script>
import $ from "jquery";
import UsersListing from "../components/Users/UsersListing.vue";
import RolesData from "@/components/Roles/RolesData.vue";
export default {
  name: "UsersPage",
  components: {
    UsersListing,
    RolesData,
  },
  async mounted() {
    $("body").removeClass("sidebar-main");
  },
  computed: {
    iAT() {
      return this.$store.state.user.userInfo.role_name;
    },
  },
  watch: {
    async iAT(newValue) {
      if (this.$store.state.user.userInfo.role_name === "user") {
        this.$router.push({ name: "Home" });
      }
      return newValue;
    },
  },
};
</script>
